import Box, { BoxProps } from '../kit/box'
import { colors } from '@theme'
import React, { useState } from 'react'

interface BarChartProps extends BoxProps {
  height: number
  barColor: keyof typeof colors
  valueList: number[]
}

const BarChart: React.FC<BarChartProps> = ({
  height,
  barColor,
  valueList,
  ...boxProps
}) => {
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const maxValue = Math.max(...valueList, 1) // Prevents division by zero
  const padding = boxProps.padding ? parseInt(boxProps.padding as string) : 0

  return (
    <Box
      flex='1 0 auto'
      justifyContent='space-between'
      height={height + 2 * padding}
      flexDirection='row-reverse'
      alignItems='end'
      onLayout={event => {
        setContainerWidth(event.nativeEvent.layout.width)
      }}
      {...boxProps}
    >
      {valueList.map((value, index) => {
        const barWidthValue = containerWidth / (2 * valueList.length)
        const barHeight = (value / maxValue) * height

        return (
          <Box
            flex='0 1 auto'
            style={{ width: barWidthValue }}
            key={index}
            height={barHeight}
            backgroundColor={barColor}
            borderTopLeftRadius='xlarge'
            borderTopRightRadius='xlarge'
          />
        )
      })}
    </Box>
  )
}

export default BarChart
